import React, { useContext } from "react";
import { View, Text, FlatList, Image, TouchableOpacity, useWindowDimensions, StyleSheet } from "react-native";
import Config from "../config/Config";
import { CartContext } from "../context/CartContext";
import { ProductsContext } from "../context/ProductsContext";

const WIDTH_TRESHOLD = 640;

const config = new Config();

const CartElement = (props) => {
    const { width, height } = useWindowDimensions();
    const { cart, emptyCart, getCartTotal } = useContext(CartContext);
    const { updateSelectedProducts } = useContext(ProductsContext);
    
    total = getCartTotal();
    const orderFontSize = props.action === 'create' ? 14 : 16;
    const portrait = (width < WIDTH_TRESHOLD);

    const ifExists = (value) => {
        return typeof(value) === 'undefined' ? false : (value !== null && value !== '');
    }

    // const neighborhood = props.address.neighborhood ? `[ ${props.address.neighborhood} ]` : "";

    return (
        <View style={[styles.cartView, {height: props.maxHeight}]}>
            {!props.hideTitle && !emptyCart() &&
                <Text style={styles.orderTitle}>Resumo do Pedido</Text>
            }
            {emptyCart() &&
                <View style={{ flexGrow: 1, justifyContent: 'center' }}>
                    <Image style={styles.logo} source={config.HOME_LOGO} />
                </View>
            }
            {!emptyCart() && 
            <FlatList 
                contentContainerStyle={[styles.listStyle]}
                LisHeaderComponent={<Text></Text>}
                ListFooterComponent={<Text></Text>}
                numColumns = {1}
                data={cart.items.concat(cart.shippings ? cart.shippings : []).concat(cart.fees ? cart.fees : [])}
                keyExtractor={product => product.id}
                renderItem={({ item }) => {
                    return (
                        <View style={styles.cartItem}>
                            {props.origin !== 'ifood' && props.action === 'edit' && item.sku &&
                                <View style={styles.controlsView}> 
                                    <TouchableOpacity
                                        onPress={() => {
                                            if (item.quantity > 0) {
                                                const newItem = { ...item, quantity: item.quantity - 1 };
                                                updateSelectedProducts(newItem);
                                            }
                                        }}>
                                        <Image style={styles.plusMinusIcon} source={require("../../assets/minus.png")} />
                                    </TouchableOpacity>
                                    <TouchableOpacity
                                        onPress={() => {
                                            const newItem = { ...item, quantity: item.quantity + 1 };
                                            updateSelectedProducts(newItem);
                                    }}>
                                        <Image style={styles.plusMinusIcon} source={require("../../assets/plus.png")} />
                                    </TouchableOpacity>
                                </View>
                            }
                            <View style={styles.itemInfo}>
                                <View style={{alignContent: 'flex-start', flexDirection: 'row'}}>
                                    {item.sku &&
                                        <Text style={{fontSize: orderFontSize}}>
                                            {item.quantity} x
                                        </Text>
                                    }
                                    <Text style={{fontSize: orderFontSize, marginLeft: 10}}>
                                        {item.fullName ? item.fullName : item.name} (R$ {parseFloat(item.price).toFixed(2)})
                                    </Text>
                                </View>
                                {!portrait && props.action !== 'create' &&
                                    <View style={{alignContent: 'flex-end'}}>
                                        <Text style={{fontSize: orderFontSize}}>
                                            R$ {parseFloat(item.quantity * item.price).toFixed(2)}
                                        </Text>
                                    </View>
                                }
                            </View>
                            {props.action === 'create' &&
                                <TouchableOpacity
                                    style={styles.trashArea}
                                    onPress={() => {
                                        const newItem = { ...item, quantity: 0 };
                                        updateSelectedProducts(newItem);
                                    }}>
                                    <Image style={styles.trashIcon} source={require("../../assets/remove.png")} />
                                </TouchableOpacity>
                            }
                        </View>
                    );
                }}
            />
            }
            {!emptyCart() &&
                <View style={{marginLeft: 10}}> 
                    {ifExists(props.customerNotes) &&
                        <Text style={{marginBottom: 5, fontWeight: 'bold'}}>
                            Notas: {props.customerNotes}
                        </Text>
                    }
                    {ifExists(props.address) &&
                        <View>
                            <Text>Fone: {props.address.phone}</Text>
                            <Text>Endereço: {props.address.address_1} {props.address.number} {props.address.address_2} {props.address.neighborhood ? `[ ${props.address.neighborhood} ]` : ''}</Text>
                        </View>
                    }
                    <Text style={props.action === 'create' ? styles.totalTextSmall : styles.totalTextBig}>
                        Total: R$ {total.toFixed(2)}
                    </Text>
                </View>
            }
        </View>
    );
}

const styles = StyleSheet.create({
    logo: {
        width: 160,
        height: 80,
        resizeMode: "contain",
        alignSelf: 'center'
    },
    cartView: {
        backgroundColor: '#edc',
        marginHorizontal: 0,
        paddingTop: 3,
        paddingHorizontal: 5,
        borderBottomLeftRadius: 10,
        borderBottomRightRadius: 10
    },
    orderTitle: {
        fontSize: 18,
        paddingTop: 5,
        fontWeight: 'bold',
        alignSelf: 'center'
    },
    listStyle: {
        paddingHorizontal: 3,
    },
    cartItem: {
        flexDirection: 'row',
        paddingVertical: 8,
        borderBottomWidth: 1,
        marginHorizontal: 5
    },
    itemInfo: {
        flexDirection: 'row', 
        flex: 8, 
        justifyContent: 'space-between'
    },
    totalTextSmall: {
        fontSize: 15,
        fontWeight: "bold",
        marginTop: 5,
        marginBottom: 10,
        alignSelf: 'center'
    },
    totalTextBig: {
        fontSize: 17,
        fontWeight: "bold",
        margin: 10,
        alignSelf: 'flex-end'
    },
    trashArea: {
        flex: 1
    },
    trashIcon: {
        marginLeft: 10,
        width: 22,
        height: 22,
        alignSelf: 'flex-start'
    },
    controlsView: {
        flexDirection: 'row',
        justifyContent: 'flex-start',
        width: 90
    },
    plusMinusIcon: {
        marginHorizontal: 10,
        height: 22,
        width: 22,
    }
});

export default CartElement;
